var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect } from 'react';
var ELEMENT_VISIBILITY_STATE;
(function (ELEMENT_VISIBILITY_STATE) {
    ELEMENT_VISIBILITY_STATE[ELEMENT_VISIBILITY_STATE["VISIBLE"] = 0] = "VISIBLE";
    ELEMENT_VISIBILITY_STATE[ELEMENT_VISIBILITY_STATE["INVISIBLE"] = 1] = "INVISIBLE";
})(ELEMENT_VISIBILITY_STATE || (ELEMENT_VISIBILITY_STATE = {}));
const ElementVisibilitySensor = (_a) => {
    var { onVisibilityChange, senseOnce } = _a, props = __rest(_a, ["onVisibilityChange", "senseOnce"]);
    const elementRef = useRef(null);
    const io = useRef(null);
    useEffect(() => {
        const newIO = new IntersectionObserver(handleIntersection);
        if (elementRef.current !== null) {
            newIO.observe(elementRef.current);
        }
        io.current = newIO;
        return () => {
            var _a;
            (_a = io.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, []);
    const unobserve = () => {
        var _a;
        elementRef.current && ((_a = io.current) === null || _a === void 0 ? void 0 : _a.unobserve(elementRef.current));
    };
    const handleIntersection = (entries, _) => {
        entries.forEach((entry) => {
            const elementIsVisible = entry.isIntersecting
                ? ELEMENT_VISIBILITY_STATE.VISIBLE
                : ELEMENT_VISIBILITY_STATE.INVISIBLE;
            if (elementIsVisible === ELEMENT_VISIBILITY_STATE.VISIBLE &&
                senseOnce) {
                unobserve();
            }
            onVisibilityChange(elementIsVisible === ELEMENT_VISIBILITY_STATE.VISIBLE, entry.target);
        });
    };
    return React.createElement("div", Object.assign({}, props, { ref: elementRef }));
};
export default ElementVisibilitySensor;
